export class Permiso {
   public permisoId: string;
   public codigo: string;
   public nombre: string;
   public asignado: boolean;
   public activo: boolean;
   public nombrePadre: string;
   public nombreCompuesto: string;
}
